import PropTypes from 'prop-types';
import * as React from 'react';

const svgClose = () => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path
        d="M22.1667 7.97898L20.5217 6.33398L14 12.8557L7.47837 6.33398L5.83337 7.97898L12.355 14.5007L5.83337 21.0223L7.47837 22.6673L14 16.1457L20.5217 22.6673L22.1667 21.0223L15.645 14.5007L22.1667 7.97898Z"
        fill="#496A86"
      />
    </svg>
  );
};

svgClose.propTypes = {
  className: PropTypes.string
};

export default svgClose;
